module.exports = __webpack_public_path__ + "static/media/icon-face.43b1b7b7.svg";